module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousClientView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_vm._v("Add Client Department")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.permissionStatus,
      "list": _vm.clientList,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client"
    },
    model: {
      value: (_vm.clientDetails),
      callback: function($$v) {
        _vm.clientDetails = $$v
      },
      expression: "clientDetails"
    }
  }), _vm._v(" "), (!_vm.clientDetail.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Account Manager")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.userList,
      "selected-options": _vm.accountManagerList,
      "placeholder": "select"
    },
    on: {
      "select": _vm.SelectAM
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Customize Service")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.userList,
      "selected-options": _vm.CsList,
      "placeholder": "select"
    },
    on: {
      "select": _vm.SelectCS
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Documentary")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.userList,
      "selected-options": _vm.documentaryList,
      "placeholder": "select"
    },
    on: {
      "select": _vm.selectDoc
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center mt-3"
  }, [_c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "variant": "primary",
      "disabled": _vm.permissionStatus,
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addClientDept
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (false) ? _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientType"
    }
  }, [_vm._v("Client Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.permissionStatus,
      "list": _vm.clientTypeList,
      "option-value": "clientTypeVal",
      "option-text": "clientTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.clientDetail.clientType),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "clientType", $$v)
      },
      expression: "clientDetail.clientType"
    }
  }), _vm._v(" "), (!_vm.clientDetail.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "clientName",
      "id": "clientName",
      "disabled": _vm.clientDetail.clientId != '' &&
        this.$sessionsStorage.get('designation') != 'Admin' ?
        true :
        false
    },
    model: {
      value: (_vm.clientDetail.clientName),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "clientName", $$v)
      },
      expression: "clientDetail.clientName"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "name": "phoneKYC",
      "id": "phoneKYC",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.phoneKYC),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "phoneKYC", $$v)
      },
      expression: "clientDetail.phoneKYC"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.phoneKYC) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.phoneKYCError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Email Address")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "email",
      "id": "email",
      "disabled": _vm.permissionStatus
    },
    on: {
      "keyup": _vm.isEmailValid
    },
    model: {
      value: (_vm.clientDetail.email),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "email", $$v)
      },
      expression: "clientDetail.email"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.emailError))]) : _vm._e(), _vm._v(" "), (_vm.clientDetail.email) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmailFormat))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Alternate Email")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "altMail",
      "id": "altMail",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.altMail),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "altMail", $$v)
      },
      expression: "clientDetail.altMail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("PAN No.(AAAAA1234A)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "panNO",
      "id": "panNO",
      "disabled": _vm.permissionStatus
    },
    on: {
      "keyup": function($event) {
        _vm.PANErrorValid1()
      }
    },
    model: {
      value: (_vm.clientDetail.panNO),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "panNO", $$v)
      },
      expression: "clientDetail.panNO"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.panNO) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.panNOError))]) : _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PANErrorValid))])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IEC Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "clientName",
      "id": "clientName",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.IEC),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "IEC", $$v)
      },
      expression: "clientDetail.IEC"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "companyType"
    }
  }, [_vm._v("Type of Company")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.permissionStatus,
      "list": _vm.companyTypeList,
      "option-value": "companyTypeVal",
      "option-text": "companyTypeText",
      "placeholder": "Select Company Type"
    },
    model: {
      value: (_vm.clientDetail.companyType),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "companyType", $$v)
      },
      expression: "clientDetail.companyType"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.companyType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.companyTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "State"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.permissionStatus,
      "list": _vm.stateDetail,
      "option-value": "stateId",
      "option-text": "stateName",
      "placeholder": "Select State "
    },
    model: {
      value: (_vm.clientDetail.state),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "state", $$v)
      },
      expression: "clientDetail.state"
    }
  }), _vm._v(" "), (!_vm.clientDetail.state) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stateError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "companyType"
    }
  }, [_vm._v("Company Permitted")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.permissionStatus,
      "list": _vm.companyPermitList,
      "option-value": "permitVal",
      "option-text": "permitText",
      "placeholder": "Select Permit Type"
    },
    model: {
      value: (_vm.clientDetail.permitted),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "permitted", $$v)
      },
      expression: "clientDetail.permitted"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.permitted) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.permittedError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("TAN No.(AAAA12345A)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "tanNO",
      "id": "tanNO",
      "disabled": _vm.permissionStatus
    },
    on: {
      "keyup": function($event) {
        _vm.TANErrorValid1()
      }
    },
    model: {
      value: (_vm.clientDetail.tanNO),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "tanNO", $$v)
      },
      expression: "clientDetail.tanNO"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.tanNO) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.tanNOError))]) : _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.TANErrorValid))])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.clientDetail.permitted != 'GSTUnregistered') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "StateCode",
      "id": "StateCode",
      "disabled": ""
    },
    model: {
      value: (_vm.clientDetail.stateCode),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "stateCode", $$v)
      },
      expression: "clientDetail.stateCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.clientDetail.permitted != 'GSTUnregistered') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GSTN No.(AAAAA1234A1Z5)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "GSTN",
      "id": "GSTN",
      "disabled": _vm.permissionStatus ?
        true :
        _vm.clientDetail.state == '' ?
        true :
        false
    },
    on: {
      "keyup": function($event) {
        _vm.GSTNErrorValid1()
      }
    },
    model: {
      value: (_vm.clientDetail.GSTN),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "GSTN", $$v)
      },
      expression: "clientDetail.GSTN"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.GSTN) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.GSTNError))]) : _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.GSTNErrorValid))])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Corporate Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": function (value) { return value.toUpperCase(); },
      "name": "corporateAddress",
      "id": "corporateAddress",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.corporateAddress),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "corporateAddress", $$v)
      },
      expression: "clientDetail.corporateAddress"
    }
  })], 1), _vm._v(" "), (!_vm.clientDetail.corporateAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.corporateAddressError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Credit Days")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "creditDays",
      "id": "creditDays",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.creditDays),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "creditDays", $$v)
      },
      expression: "clientDetail.creditDays"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('span', [_vm._v("Segment :")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'segment' + (index + 1),
        "id": 'segment' + (index + 1),
        "disabled": _vm.permissionStatus
      },
      model: {
        value: (_vm.clientDetail.segment[index]),
        callback: function($$v) {
          _vm.$set(_vm.clientDetail.segment, index, $$v)
        },
        expression: "clientDetail.segment[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', [_c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v("Add Client Factory")]), _vm._v(" "), (_vm.multiFactError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(this.multiFactError))]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h5', [_vm._v("Client Factory Details !")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(this.viewAllFactory.length == 0 ? _vm.multiFactError : ""))])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Factory Title-Location]( e.g : Pridel Pvt\n                            Ltd-Delhi)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "factoryTitle",
      "id": "factoryTitle",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.factoryModal.factoryTitle),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryTitle", $$v)
      },
      expression: "factoryModal.factoryTitle"
    }
  }), _vm._v(" "), (!_vm.factoryModal.factoryTitle) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryTitleError))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": function (value) { return value.toUpperCase(); },
      "name": "factoryAddress1",
      "id": "factoryAddress1",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.factoryModal.factoryAddress1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryAddress1", $$v)
      },
      expression: "factoryModal.factoryAddress1"
    }
  }), _vm._v(" "), (!_vm.factoryModal.factoryAddress1) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.factoryAddress1Error))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "pull-left ml-4",
    attrs: {
      "disabled": _vm.factoryModal.factoryAddress1 == '' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.fetchLatLog
    }
  }, [_vm._v("Get Lat/Long")])], 1)]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Latitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.latitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "latitude", $$v)
      },
      expression: "factoryModal.latitude"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Longitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.longitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "longitude", $$v)
      },
      expression: "factoryModal.longitude"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GSTIN No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "GSTIN1",
      "id": "GSTIN1",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.factoryModal.GSTIN1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "GSTIN1", $$v)
      },
      expression: "factoryModal.GSTIN1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "block": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addClient('')
      }
    }
  }, [_vm._v(_vm._s(_vm.factoryModal.multiFactoryId == "" ? "Add " : "Update ") + "\n                    Factory\n                  ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close\n                  ")])], 1)], 1)]), _vm._v(" "), (_vm.viewAllFactory.length > 0) ? _c('div', {
    staticClass: "gutr"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "factoryDetails"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("Factory Title")]), _vm._v(" "), _c('th', [_vm._v("Factory Address")]), _vm._v(" "), _c('th', [_vm._v("Factory GSTIN")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewAllFactory), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (item.enableEdit == '1') ? _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.EditFactory(item)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.factoryTitle) + "\n                    ")]) : _c('td', [_vm._v(_vm._s(item.factoryTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.factoryAddress1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GSTIN1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.longitude))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteData(item.multiFactoryId)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])]) : _vm._e()], 1), _vm._v(" "), (_vm.contactPersonArry.length > 0) ? _c('h5', {
    staticClass: "mt-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Contact Person")])], 1) : _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.AddMoreContactP
    }
  }, [_vm._v("Add Contact Person")]), _vm._v(" "), (_vm.contactPersonArry.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("\n                    Sr No."), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.AddMoreContactP
    }
  }, [_vm._v("Add More\n                      ")])], 1), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Contact")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Dept")]), _vm._v(" "), _c('th', [_vm._v("Designation")]), _vm._v(" "), _c('th')]), _vm._v(" "), _vm._l((_vm.contactPersonArry), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.phone),
        callback: function($$v) {
          _vm.$set(item, "phone", $$v)
        },
        expression: "item.phone"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.email),
        callback: function($$v) {
          _vm.$set(item, "email", $$v)
        },
        expression: "item.email"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.dept),
        callback: function($$v) {
          _vm.$set(item, "dept", $$v)
        },
        expression: "item.dept"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.deg),
        callback: function($$v) {
          _vm.$set(item, "deg", $$v)
        },
        expression: "item.deg"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeCp(index)
        }
      }
    }, [_vm._v("Remove")])], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b', [_vm._v("KYC Done :")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "isKYC1",
      "name": "isKYC1",
      "md-value": "Yes",
      "disabled": _vm.permissionStatus
    },
    on: {
      "change": _vm.AddMoreDocs
    },
    model: {
      value: (_vm.clientDetail.isKYC),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "isKYC", $$v)
      },
      expression: "clientDetail.isKYC"
    }
  }, [_vm._v("Yes")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-radio', {
    staticClass: "md-primary margn-0px",
    attrs: {
      "id": "isKYC2",
      "name": "isKYC2",
      "md-value": "No",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.clientDetail.isKYC),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "isKYC", $$v)
      },
      expression: "clientDetail.isKYC"
    }
  }, [_vm._v("No")])], 1)], 1), _vm._v(" "), (_vm.showDocSection.length > 0 || _vm.clientDetail.isKYC == 'Yes') ? _c('div', {
    staticClass: "mt-3"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Document Name")]), _vm._v(" "), _c('th', [_vm._v("Upload Document")]), _vm._v(" "), _c('th', [_vm._v("View")]), _vm._v(" "), _c('th', [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.AddMoreDocs
    }
  }, [_vm._v("Add More\n                      ")])], 1)]), _vm._v(" "), _vm._l((_vm.showDocSection), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "disabled": _vm.permissionStatus,
        "list": _vm.docList,
        "option-value": "docV",
        "option-text": "docT",
        "placeholder": "Select Document"
      },
      model: {
        value: (item.kycDocName),
        callback: function($$v) {
          _vm.$set(item, "kycDocName", $$v)
        },
        expression: "item.kycDocName"
      }
    })], 1), _vm._v(" "), _c('td', [_c('md-input-container', {
      staticStyle: {
        "margin-top": "-35px"
      }
    }, [_c('md-file', {
      on: {
        "selected": function($event) {
          _vm.onFileChangeKyc(index, item.kycDocName)
        }
      },
      model: {
        value: (item.uploadedkycDoc),
        callback: function($$v) {
          _vm.$set(item, "uploadedkycDoc", $$v)
        },
        expression: "item.uploadedkycDoc"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [(item.uploadedkycDoc != '') ? _c('a', {
      staticClass: "showMoreData",
      attrs: {
        "href": _vm.docURL + "/" +
          "" + (item.uploadedkycDoc.includes('CLIENTKYCDOC')
                            ? ''
                            : 'CLIENTKYCDOC/') +
          item.uploadedkycDoc,
        "target": "_blank",
        "download": ""
      }
    }, [_c('u', [_vm._v("View Document - " + _vm._s(index + 1))])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeDoc(index)
        }
      }
    }, [_vm._v("Remove")])], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remark ")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": function (value) { return value.toUpperCase(); },
      "name": "remarkOtherDocument",
      "id": "remarkOtherDocument"
    },
    model: {
      value: (_vm.clientDetail.remarkOtherDocument),
      callback: function($$v) {
        _vm.$set(_vm.clientDetail, "remarkOtherDocument", $$v)
      },
      expression: "clientDetail.remarkOtherDocument"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.clientDetail.isKYC == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.clientDetail.panCard == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.panCardError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.clientDetail.isKYC == 'Yes') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.clientDetail.aadharCard == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.aadharError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "variant": "primary",
      "disabled": _vm.permissionStatus,
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addClient('csfds')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialogLocation",
    staticClass: "HereDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_c('pickupLocation')], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeModalLocation
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog2",
    staticClass: "HereDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_c('div', {
    staticClass: "box margn-0px"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('md-layout', {
    staticClass: "modal-header-set",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin": "7px"
    }
  }, [_vm._v("Contract Detail")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised md-dense modal-close-btnn",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Select Contract Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.permissionStatus,
      "list": _vm.contractListName,
      "option-value": "contractTypeVal",
      "option-text": "contractTypeText",
      "placeholder": "Select Contract Type "
    },
    model: {
      value: (_vm.contractDetailModal.contractType),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "contractType", $$v)
      },
      expression: "contractDetailModal.contractType"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.contractType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isContractError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Validity From Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.contractDetailModal.fromValidity),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "fromValidity", $$v)
      },
      expression: "contractDetailModal.fromValidity"
    }
  }), _vm._v(" "), (!_vm.contractDetailModal.fromValidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isFromValidtyError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Validity To Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.contractDetailModal.toValidity),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "toValidity", $$v)
      },
      expression: "contractDetailModal.toValidity"
    }
  }), _vm._v(" "), (!_vm.contractDetailModal.toValidity) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isToValidtyError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Monthly fixed rental for each dedicated vehicle")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "monthlyRent",
      "name": "monthlyRent",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.monthlyRent),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "monthlyRent", $$v)
      },
      expression: "contractDetailModal.monthlyRent"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.monthlyRent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isMonthlyRentError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Number of dedicated vehicles")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "noOfTrucks",
      "name": "noOfTrucks",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.noOfTrucks),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "noOfTrucks", $$v)
      },
      expression: "contractDetailModal.noOfTrucks"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.noOfTrucks) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noOfTrucksError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.contractDetailModal.contractType == 'fuelType') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Mileage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "milage",
      "name": "milage",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.milage),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "milage", $$v)
      },
      expression: "contractDetailModal.milage"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.milage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.milageError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Diesel Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "dieselRate",
      "name": "dieselRate",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.dieselRate),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "dieselRate", $$v)
      },
      expression: "contractDetailModal.dieselRate"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.dieselRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.dieselRateError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.contractDetailModal.contractType == 'freeKMType') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Free Kilometer per vehicle per months")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "allowedKm",
      "name": "allowedKm",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.allowedKm),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "allowedKm", $$v)
      },
      expression: "contractDetailModal.allowedKm"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.allowedKm) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isAllowedKmError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vehicle Modal")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleModal",
      "name": "vehicleModal",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.vehicleModal),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "vehicleModal", $$v)
      },
      expression: "contractDetailModal.vehicleModal"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.vehicleModal) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleModalError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Vehicle Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.permissionStatus,
      "list": _vm.vehicleTypeMaster,
      "option-value": "vehicleTypeId",
      "option-text": "vehicleType",
      "placeholder": "Select Vehicle Type "
    },
    model: {
      value: (_vm.contractDetailModal.vehicleType),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "vehicleType", $$v)
      },
      expression: "contractDetailModal.vehicleType"
    }
  }), _vm._v(" "), (!_vm.contractDetailModal.vehicleType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "grossWeight", $$v)
      },
      expression: "contractDetailModal.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.grossWeightError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.contractDetailModal.contractType == 'freeKMType') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Additional charges over allowed Km")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "overcharges",
      "name": "overcharges",
      "disabled": _vm.permissionStatus
    },
    model: {
      value: (_vm.contractDetailModal.overcharges),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "overcharges", $$v)
      },
      expression: "contractDetailModal.overcharges"
    }
  })], 1), _vm._v(" "), (!_vm.contractDetailModal.overcharges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.isOverChargesError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("Note:-")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              1:Toll/Green Tax to be paid actual against receipt.\n            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              2:Penalty/Challans/RTO will be borne by the Transporter.\n            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              3:Cooling period will be 2 days in a month.\n            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              4:Diesel, Driver & Maintenance will be borne by the\n              Transporter..\n            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              5:Documents will be Insurance, RC Copy, Permit, Fitness\n              Certificate of the attached vehicle should be provided at the\n              time of agreement.\n            ")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin": "0px",
      "padding": "0px",
      "color": "green"
    }
  }, [_vm._v("\n              6: Goods & Service Tax(GST) as per applicable law.\n            ")])], 1)], 1)])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.addContract
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "PopDoc",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopSave",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    staticStyle: {
      "z-index": "99999999999999"
    },
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDeleteF",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseDelete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d611a1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/clients/addClientDept.vue
// module id = 2431
// module chunks = 0